import context from '@/context'

export const initialState = {
  delinquentRetrieving: false,
  delinquentSetting: false,

  delinquentIndividuals: { individuals: [], problematicCombinations: [], comparisons: [] }
}

export const actionTypes = {
  realPersonRetrieving: 'dataCrossing/realPersonRetrieving',
  realPersonRetrieved: 'dataCrossing/realPersonRetrieved',

  problematicCombinationSetting: 'dataCrossing/problematicCombinationSetting',
  problematicCombinationSet: 'dataCrossing/problematicCombinationSet',

  clearDataCrossings: 'dataCrossing/clear',

  error: 'dataCrossing/error'
}

export const actionCreators = {
  getRealPersonDetail: (id) => dispatch => {
    dispatch({ type: actionTypes.realPersonRetrieving })

    context.api.dataCrossingService.getRealPersonDetail(id)
      .then(response => {
        dispatch({ type: actionTypes.realPersonRetrieved, data: { ...response } })
      }).catch(() => dispatch({ type: actionTypes.error }))
  },

  getDuplicateDetail: (id) => dispatch => {
    dispatch({ type: actionTypes.realPersonRetrieving })

    context.api.dataCrossingService.getDuplicateDetail(id)
      .then(response => {
        dispatch({ type: actionTypes.realPersonRetrieved, data: { ...response } })
      }).catch(() => dispatch({ type: actionTypes.error }))
  },

  setProblematicCombination: (id, isCombinationOk) => dispatch => {
    dispatch({ type: actionTypes.problematicCombinationSetting })

    context.api.dataCrossingService.setProblematicCombination(id, isCombinationOk)
      .then(() => {
        dispatch({ type: actionTypes.problematicCombinationSet, data: { id, isCombinationOk } })
      }).catch(() => dispatch({ type: actionTypes.error }))
  },

  clearDataCrossings: () => dispatch => {
    dispatch({ type: actionTypes.clearDataCrossings })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.realPersonRetrieving:
      return { ...state, delinquentRetrieving: true }
    case actionTypes.realPersonRetrieved:
      return { ...state, delinquentRetrieving: false, delinquentIndividuals: action.data }
    case actionTypes.problematicCombinationSetting:
      return { ...state, problematicCombinationSetting: true }
    case actionTypes.problematicCombinationSet:
      return { ...state,
        problematicCombinationSetting: false,
        delinquentIndividuals: { ...state.delinquentIndividuals,
          problematicCombinations:
            state.delinquentIndividuals.problematicCombinations
              .map(x => x.id === action.data.id ? { ...x, state: action.data.isCombinationOk ? 1 : 2 } : x)
        } }
    case actionTypes.clearDataCrossings:
      return { ...initialState }
    case actionTypes.error:
      return { ...state, delinquentRetrieving: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/dataCrossing.js